"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = require("vue");
var _default = exports.default = {
  __name: 'layout',
  setup(__props) {
    (0, _vue.defineComponent)({
      name: 'PageLayout'
    });
    return {
      __sfc: true
    };
  }
};